/**
 * Lot 1.A — "Demander aux participants de choisir une date".
 * Statuses of a registration that is confirmed but not yet attached to a session.
 * "À inscrire" is postponed to v2: a pending registration is born directly in
 * "Choix de date en cours".
 */
export enum DateChoiceStatusEnum {
  /** The participant has been asked to choose a session. */
  PENDING_DATE_CHOICE = "pending_date_choice",
  /** The participant reported that none of the proposed sessions suits them. */
  NO_SUITABLE_DATE = "no_suitable_date",
  /**
   * Row already handled (session chosen or registration deleted). Returned by `choice-options`
   * only: an informational state on the participant side, never an error.
   */
  RESOLVED = "resolved",
}

/** Recorded recipient of the request (AC-SUIVI.6). Only the participant is asked in v1. */
export enum DateChoiceRecipientEnum {
  PARTICIPANT = "participant",
  MANAGER = "manager",
}

/** Options of the "funnel" modal displayed when clicking "Changer de session". */
export enum DateChoiceFunnelOptionEnum {
  REGISTER_ON_SESSION = "register_on_session",
  ASK_DATE_CHOICE = "ask_date_choice",
  CHOOSE_LATER = "choose_later",
}

/**
 * Machine codes returned by the `pending-registrations` endpoints as 400s (never 409s, to avoid the
 * front logging the user out automatically). The code is the `message` of the error body, and the
 * `reason` of a skipped row in a bulk response.
 * `SESSION_FULL` also serves as a `notSelectableReason` on a session card.
 */
export enum DateChoiceErrorCodeEnum {
  /** Someone else (admin or participant) already handled the row. */
  ALREADY_RESOLVED = "ALREADY_RESOLVED",
  /** The last seat was taken between render and click. */
  SESSION_FULL = "SESSION_FULL",
  /** Session cancelled / past / no longer visible between render and click. */
  SESSION_NOT_ELIGIBLE = "SESSION_NOT_ELIGIBLE",
  /** The carrier project lost its training between the claim and the read. */
  CARRIER_TRAINING_NOT_FOUND = "CARRIER_TRAINING_NOT_FOUND",
  /**
   * The resolution created no booking. Orders dropped its own duplicate guard (`ALREADY_REGISTERED`,
   * removed from the contracts by `5659ee191`) and defers to the dedup of `createBookings`, which
   * silently skips an attendee already booked on the session and answers with an empty `invites` —
   * so this is what "the participant is already registered on this date" comes back as.
   */
  REGISTRATION_FAILED = "REGISTRATION_FAILED",
}

/** Fate of a row in a bulk registration performed by the admin. */
export enum DateChoiceOutcomeEnum {
  REGISTERED = "registered",
  SKIPPED = "skipped",
}

/**
 * `allowedActions` of a pending row (AC-SUIVI.9). The status badge is never part of it:
 * it is not editable from the details (AC-SUIVI.11).
 */
export enum DateChoiceActionEnum {
  CHOOSE_SESSION = "choose_session",
  EDIT_PRICE = "edit_price",
  VIEW_DETAILS = "view_details",
}
